"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listQueue = void 0;
const ApiClient_1 = require("../ApiClient");
const listQueue = () => ApiClient_1.apiClient.get('/api/queue');
exports.listQueue = listQueue;
